// extracted by mini-css-extract-plugin
export default {"buttonTitle":"UploadImage_buttonTitle__6EWMc","errorMessage":"UploadImage_errorMessage__bt23G","plus":"UploadImage_plus__zgdzw","img":"UploadImage_img__YlM8T"};